import { MiddlewareStore } from "store/createStore";
import { transformChatMessage } from "../chatSessionListenerUtils";
import { handleAttachment } from "./handleAttachment";
import { handleChatEnded } from "./handleChatEnded";
import { handleParticipantJoined } from "./handleParticipantJoined";
import { handleParticipantLeft } from "./handleParticipantLeft";
import { handleReceipts } from "./handleReceipts";
import { handleSmartagentMessage } from "./handleSmartagentMessage";
import { handleTranslate } from "./handleTranslate";
import { handleTranslationLanguage } from "./handleTranslationLanguage";

export const onMessage = async (
    store: MiddlewareStore,
    session: connect.CustomerChatSession,
    messageEvent: connect.ChatMessageEvent,
) => {
    const { data } = messageEvent;

    console.log('received message from connect', data);

    const messages = [

        await transformChatMessage(data, store, session)
            .then(message => handleReceipts(message, session))
            .then(message => handleTranslationLanguage(message, store, session))
            .then(message => handleTranslate(message, store, session))
            .then(message => handleParticipantJoined(message, store))
            .then(message => handleParticipantLeft(message, store, session))
            .then(message => handleChatEnded(message, store))
            .then(message => handleAttachment(message, store, session))
            // must be last to handle batch messages
            .then(message => handleSmartagentMessage(message, store))

    ].flat();

    return messages

}

